<div fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center">
  <mat-form-field>
    <mat-select
      placeholder="Order by"
      name="Order by"
      id="order_by"
      (selectionChange)="columnChanged($event)"
    >
      <mat-option *ngFor="let column of columns" [value]="column.value">
        {{ column.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-button-toggle-group
    #group="matButtonToggleGroup"
    (change)="orderDirectionChanged($event)"
    class="mb-4"
  >
    <mat-button-toggle color="accent" value="DESC">
      <mat-icon>keyboard_arrow_down</mat-icon>
    </mat-button-toggle>
    <mat-button-toggle color="accent" value="ASC">
      <mat-icon>keyboard_arrow_up</mat-icon>
    </mat-button-toggle>
  </mat-button-toggle-group>
</div>
